/**
 *
 * Fullstory
 *
 */
// eslint-disable-next-line no-unused-vars
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

const Fullstory = ({ whoami }) => {
  // Track the last external_id we identified to prevent duplicate calls
  const lastIdentifiedIdRef = useRef(null);
  // Track FS availability to trigger re-identification when FS loads async
  const [isFSReady, setIsFSReady] = useState(() => !!window.FS);

  // Monitor for FS becoming available (handles async loading)
  useEffect(() => {
    // If FS is already available, no need to poll
    if (window.FS) {
      setIsFSReady(true);
      return undefined;
    }

    // Poll for FS availability (check every 100ms)
    const intervalId = setInterval(() => {
      if (window.FS) {
        setIsFSReady(true);
        clearInterval(intervalId);
      }
    }, 100);

    // Clean up interval after 10 seconds to avoid infinite polling
    const timeoutId = setTimeout(() => {
      clearInterval(intervalId);
    }, 10000);

    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, []);

  useEffect(() => {
    const {
      email,
      external_id: externalId,
      name: displayName,
      role,
      phone_number: phone,
      time_zone: timeZone,
      account_name: accountSlug,
      user_type: userType,
      country_code: countryCode,
      locale,
    } = whoami;

    // Only identify if:
    // 1. We have a valid external_id
    // 2. It's different from the last one we identified (prevents duplicate calls)
    // 3. FullStory is available
    if (
      externalId &&
      externalId.length > 0 &&
      externalId !== lastIdentifiedIdRef.current &&
      window.FS
    ) {
      window.FS.identify(externalId, {
        displayName,
        externalId,
        email,
        role,
        phone,
        timeZone,
        accountSlug,
        userType,
        countryCode,
        locale,
      });

      // Track that we've identified this user
      lastIdentifiedIdRef.current = externalId;
    }
    // Depend on external_id and isFSReady - when FS becomes available, we should try to identify
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [whoami.external_id, isFSReady]);

  return null;
};

Fullstory.propTypes = {
  whoami: PropTypes.object,
};

export default Fullstory;
